var changer = require('./themeColorChanger.js')
var varyColor = require('./varyColor')
var getElementUISeries = require('../forElementUI/getElementUISeries')

module.exports = {
    changer: changer,
    varyColor: varyColor,
    getElementUISeries: getElementUISeries
}
